module.exports = __webpack_public_path__ + "img/Flag_of_Finland.1d1965e5.svg";